<div
  *ngIf="projectsLoaded && projects.length && isEnabled"
  class="project-suggestion-slider"
>
  <h3>{{ title | translate }}</h3>
  <div class="project-suggestion-slider__slides">
    <swiper-container
      [slidesPerView]="1.25"
      *ngIf="projectsLoaded && projects.length > 1"
    >
      <swiper-slide *ngFor="let project of projects">
        <app-card
          [project]="project"
          [className]="'card--update project-suggestion'"
          [type]="CardType.PROJECT_SUGGESTION"
          [withHeader]="true"
          [withCoverImage]="true"
          [dateAdded]="project.startDate"
          [language]="language"
        ></app-card>
      </swiper-slide>
    </swiper-container>
  </div>
  <app-card
    *ngIf="projectsLoaded && projects.length === 1"
    [project]="projects[0]"
    [type]="CardType.PROJECT_SUGGESTION"
    [withHeader]="true"
    [withCoverImage]="true"
    [dateAdded]="projects[0].startDate"
  ></app-card>
</div>
<ngx-skeleton-loader
  *ngIf="!projectsLoaded && isEnabled"
  [theme]="{
    height: '32rem',
    'border-radius': '16px',
    'margin-top': '8px'
  }"
></ngx-skeleton-loader>
